import { Divider, Empty, Flex, Form, Skeleton, Spin, Typography } from "antd";

import { observer } from "mobx-react-lite";
import { useNotificationContext } from "providers";
import { useEffect } from "react";
import { useStores } from "stores";
import { CustomButton } from "ui";
import { requestWithNotify } from "utils";

export const OfferCodesModal = observer(() => {
  const { actionModals, offerDoc } = useStores();
  const { openNotification } = useNotificationContext();

  useEffect(() => {
    requestWithNotify({
      fetchFn: () => offerDoc.getOfferCodes(),
      openNotification: openNotification,
    });
  }, []);

  const handleCloseModal = () => {
    actionModals.closeAll();
  };

  return (
    <Flex vertical gap="large">
      <Flex vertical>
        <Typography.Title>Список кодов</Typography.Title>
        <Divider style={{ margin: 0 }} />
        {offerDoc.codesStatutes.loading ? (
          <Flex justify="center" vertical gap="small">
            <Skeleton active />
            <Skeleton active />
            <Skeleton active />
          </Flex>
        ) : (
          <Flex vertical gap="small">
            <Typography.Title level={5}>Оферта</Typography.Title>
            <Flex vertical gap="small">
              {offerDoc.fieldCodes.length > 1 ? (
                offerDoc.fieldCodes.map((code, i) => {
                  return (
                    <Flex key={i} justify="space-between">
                      <Typography.Text className="text-description">{code.templateParameterName}</Typography.Text>
                      <Typography.Text style={{ width: "250px" }} strong>
                        {code.description}
                      </Typography.Text>
                    </Flex>
                  );
                })
              ) : (
                <Empty description="Нет данных по кодам" />
              )}
            </Flex>
          </Flex>
        )}
      </Flex>

      <Form.Item>
        <CustomButton htmlType="button" style={{ width: "100%" }} onClick={handleCloseModal}>
          Закрыть
        </CustomButton>
      </Form.Item>
    </Flex>
  );
});
